import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { PersonalisationBreakdown } from 'src/components/molecules/PriceBreakdown/components/PriceBreakdown';
import { getPersonalisationAmount } from 'src/utils';
import { SelectedPersonalisationsRecord } from '../types';

export const getPersonalisationBreakdown = (
  personalisations: SelectedPersonalisationsRecord,
  currency: CurrencyCode,
): PersonalisationBreakdown => {
  const defaults = { amountAdded: 0, amountRemoved: 0 };

  return Object.values(personalisations).reduce((totalBreakdown, optionSelection) => {
    const currentBreakdown = optionSelection!.reduce(({ amountAdded, amountRemoved }, opt) => {
      const { value, isNegative } = getPersonalisationAmount(currency, opt.priceModifier);

      return {
        amountAdded: isNegative ? amountAdded : amountAdded + value,
        amountRemoved: isNegative ? amountRemoved + value : amountRemoved,
      };
    }, defaults);

    return {
      amountAdded: totalBreakdown.amountAdded + currentBreakdown.amountAdded,
      amountRemoved: totalBreakdown.amountRemoved + currentBreakdown.amountRemoved,
    };
  }, defaults);
};
